/**
 * TCF Report Constants
 */

// Re-export the generic constants that are shared with the cause-report tree.
export {
  CAUSE_REPORT_STALE_TIME,
  DELTA_THRESHOLDS,
  DIALOG_RECORDS_PAGE_SIZE,
} from '../../cause-report/constants';

/** Query keys for React Query (TCF-namespaced) */
export const tcfReportKeys = {
  all: ['tcf-report'] as const,
  overview: (datasetId: string, filters: Record<string, unknown>) =>
    [...tcfReportKeys.all, 'overview', datasetId, filters] as const,
};

/** Query keys for TCF outcomes */
export const tcfOutcomesKeys = {
  all: [...tcfReportKeys.all, 'outcomes'] as const,
  list: (datasetId: string, filters: Record<string, unknown>) =>
    [...tcfOutcomesKeys.all, 'list', datasetId, filters] as const,
  records: (datasetId: string, outcomeId: string, filters: Record<string, unknown>) =>
    [...tcfOutcomesKeys.all, 'records', datasetId, outcomeId, filters] as const,
  trends: (datasetId: string, outcomeId: string, filters: Record<string, unknown>, aggregation?: string) =>
    [...tcfOutcomesKeys.all, 'trends', datasetId, outcomeId, filters, aggregation] as const,
  topCauses: (datasetId: string, outcomeId: string, filters: Record<string, unknown>) =>
    [...tcfOutcomesKeys.all, 'top-causes', datasetId, outcomeId, filters] as const,
};

/** TCF outcome colors — frontend constants (display order below) */
export const TCF_OUTCOMES: Record<string, { color: string }> = {
  tcf_outcome_1_fair_treatment: { color: '#4342F5' },
  tcf_outcome_2_suitable_products: { color: '#0EA5E9' },
  tcf_outcome_3_clear_information: { color: '#10B981' },
  tcf_outcome_4_suitable_advice: { color: '#F59E0B' },
  tcf_outcome_5_product_performance: { color: '#EF4444' },
  tcf_outcome_6_no_post_sale_barriers: { color: '#8B5CF6' },
};

/** Display order for the six TCF outcomes (outcome 1..6) */
export const TCF_OUTCOME_DISPLAY_ORDER: string[] = [
  'tcf_outcome_1_fair_treatment',
  'tcf_outcome_2_suitable_products',
  'tcf_outcome_3_clear_information',
  'tcf_outcome_4_suitable_advice',
  'tcf_outcome_5_product_performance',
  'tcf_outcome_6_no_post_sale_barriers',
];
